import React, { useState, useEffect, useContext, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import 'react-times/css/classic/default.css';
import {toast} from "react-toastify";

const ViewMom = ({
    match,
    history,
    getCorpClientList,
    getMeetingById,
    getMomList,
    }) => { const inputs = {};
            const { id } = useParams();
            const [siteId, setSiteId] = useState();
            const { baseUrl } = useContext(BaseUrl);
            const [isModal, setIsModal] = useState(false);
            const [isLoading, setIsLoading] = useState(false);
            const [formData, setData] = useState(inputs);
            const [isFocus, setIsFocus] = useState(false);
            const [tableData, setTableData] = useState([]);
            const [ccData, setCcData] = useState([]);
            const [details, setDetails] = useState([]);

            // const handleSubmit = async () => {
            //    const data = {
            //     'inputList' : inputList,
            //     'inputList2' : inputList2,
            //     'category' : category,
            //     'to': toState,
            //     'client_id': clientId,
            //     'site_id': siteId
            //    }
            //    console.log(data);
            //     (async () => {
            //         setIsLoading(true);
            //         const res = await createAndSendMom(data);
            //         setIsLoading(false);
            //         if (res) {
            //           if(res == true) {
            //             toast.success('MoM send successfully.');             
            //             setTimeout(history.push(`${baseUrl}/brand-activation/scheduled-meeting`), 7000);               
            //           }  
            //         }
            //     })();
            // }

            const handleDateHide = () => {
                if (formData.scheduled_date) {
                  setIsFocus(true);
                }
            };

            const handleDateChange = (date, dateString) => {
                console.log(date);
                // setData({ ...formData, scheduled_date: dateString });
            }; 

            useEffect(() => {
                setSiteId(match.params.siteId);
                if (getMomList !== null){
                    (async () => {
                        setIsLoading(true);
                        const res = await getMomList(match.params.id);
                        if(res) {
                          setTableData(res.fulldata);
                          //console.log(res.fulldata);
                          setCcData(res.cc);
                        }
                        setIsLoading(false);
                      })();
                }
                  
              }, [getMomList, match.params.siteId]); 

        return(
            <Layout
            title={localization.viewList}
            isGoback
            isLoading={isLoading}
            linkFlag
            linkUrl={`${baseUrl}/brand-activation/scheduled-meeting`}
          >
          <div className="container-fluid">
          <table className="panel-table table table-bordered">
            <thead>
                <tr>
                   <th>S.No</th> 
                   <th style={{'width':'20%'}}>Categoty</th> 
                   <th style={{'width':'20%'}}>To</th> 
                   <th style={{'width':'20%'}}>CC</th> 
                   <th style={{'text-align':'center','width':'35%'}}>Details</th> 
                </tr>
            </thead>
            <tbody>
            {tableData.map((item, x) => 
                <tr key={x}>
                   <td>{x+1}</td> 
                   <td>{item.category}</td> 
                   <td style={{'word-break':'break-all'}}>{item.to_mail}</td> 
                   <td style={{'word-break':'break-all'}}>{ccData[x]}</td> 
                  
                   <td>
                     <table>
                      <thead>
                        <tr>
                          <th>Agenda</th>
                          <th>Timeline</th>
                          <th>Responsibility</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                      {item && item.details && item.details.map((val, i) => {
                        return (
                          <tr key={i}>
                          <td>{val.agenda}</td>
                          <td>{val.timeline}</td>
                          <td>{val.responsibility}</td>
                          <td>{val.description}</td>
                        </tr> 
                        );                 
                        }                   
                       )}
                      </tbody>                   
                     </table>
                    </td> 
                </tr> 
              )}
            </tbody>
          </table>
          {tableData.length < 1 &&
              <div style={{'text-align':'center','margin-top':'18px'}}>
                No record found.
              </div>
          }
          </div>
          </Layout>
        );

    };
export default ViewMom;